(function () {
    'use strict';
    var m = angular.module('common');
    m.factory('oauthPopup', function () {
        function popupWindow(url, title, w, h) {
            var left = screen.width / 2 - w / 2;
            var top = screen.height / 2 - h / 2;
            return window.open(url, title, 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);
        }
        return function (url) {
            var win = popupWindow(url, 'SignIn', 800, 500);
            win.focus();
        };
    });
}());